/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Drawer, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import { FormApi, SubmissionErrors } from 'final-form';
import { StaffSelectorAutoComplete } from '../selectors/StaffSelectorAutoComplete';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { KeyboardDatePicker } from '@material-ui/pickers/DatePicker/DatePicker';
import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import { showNotification } from '../../App';
import moment from 'moment';
import { useTenant } from '../../hooks/useTenant';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { ApplicationSettingsData, ChargeRateSyncSettings, retrieveApplicationSettingsData } from '../../applicationSettings/ApplicationSettingsRepository';

const useStyles = makeStyles({
    paperRoot: {
        maxWidth: '650px',
        padding: '15px'
    },
    textField: {
        width: '100%'
    },
    butotnContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 -10px',
        justifyContent: 'flex-end'
    },
    actionButton: {
        margin: '0 10px'
    },
    title: {
        fontSize: '14px',
        fontWeight: 600
    }
});

interface EditStaffBudgetDrawerProps {
    open: boolean;
    onClose?: () => void;
    // tslint:disable-next-line: no-any
    data: any;
}

interface EditStaffBudgetForm {
    partyGuid: string;
    startDate: Date | null;
    endDate: Date | null;
    staffClassification: IAutoCompleteItem | null;
    standardChargeRate?: number | null;
}

interface ApplicationSettingsState {
    chargeRateSyncSettings: ChargeRateSyncSettings | null;
}

export const EditStaffBudgetDrawer: React.FC<EditStaffBudgetDrawerProps> = (props) => {
    const classes = useStyles();
    const tenant = useTenant();
    
    const [showDiscard, setShowDiscard] = useState(false);

    const [formState] = React.useState<EditStaffBudgetForm>({
        partyGuid: props.data.staffGuid,
        startDate: props.data.startDate ? props.data.startDate : null,
        endDate: props.data.endDate ? props.data.endDate : null,
        staffClassification: props.data.staffRole ? { label: props.data.staffRole, value: props.data.staffRole } : null,
        standardChargeRate: props.data.standardChargeRate ? props.data.standardChargeRate : null
    });

    const [pageState, setPageState] = useState<ApplicationSettingsState>({
            chargeRateSyncSettings:    null,
        });

    // tslint:disable-next-line: no-any
    const [updateStaff, updateStaffProperty] = useMutation<any, UpdateStaffMutationParams>(UPDATE_STAFF_MUTATION);
    // tslint:disable-next-line: no-any
    const [updateExtendedStaff, updateExtendedStaffProperty] = useMutation<any, UpdateExtendedStaffMutationParams>(UPDATE_EXTENDED_STAFF_MUTATION);

    const fetchApplicationSettings = () => {
        retrieveApplicationSettingsData(
            false,
            // tslint:disable-next-line: no-console
            (data: ApplicationSettingsData) => onApplicationSettingsRetrieved(data),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onApplicationSettingsRetrieved = (data: ApplicationSettingsData) => {
        setPageState((prevState) => {
            return {
                ...prevState,
                chargeRateSyncSettings: data.settings.applications.chargeRateSyncSettings,
            };
        });
    };
    
    useEffect(() => {
        if (updateStaffProperty.data && updateStaffProperty.data.updateStaff) {
            showNotification(null, 'Successfully submitted', 'info');  
            if (props.onClose) {
                props.onClose();
            }
        }
    // tslint:disable-next-line: align
    }, [updateStaffProperty.data]);

    useEffect(() => {
        if (updateExtendedStaffProperty.data && updateExtendedStaffProperty.data.updateExtendedStaff) {
            showNotification(null, 'Successfully submitted', 'info');
            if (props.onClose) {
                props.onClose();
            }
        }
    // tslint:disable-next-line: align
    }, [updateExtendedStaffProperty.data]);

    // fetch once when the drawer opens, not on every pageState update (fetch's own result was re-triggering itself)
    useEffect(() => {
        fetchApplicationSettings();
    }, []);

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    // tslint:disable-next-line: no-any
    const onSubmit = (values: EditStaffBudgetForm, form: FormApi<EditStaffBudgetForm>, callback?: (errors?: SubmissionErrors) => void) => {
        var isLeap = tenant.data!.tenant.sourceSystem.toLocaleLowerCase() === 'leap';

        if (isLeap) {
            updateStaff({
                variables: {
                    partyGuid: values.partyGuid,
                    endDate: values.endDate ? moment(values.endDate).toDate() : values.endDate,
                    staffRole: values.staffClassification ? values.staffClassification.value : null,
                    startDate: values.startDate ? moment(values.startDate).toDate() : values.startDate,
                    updateFromRedView: true,
                    standardChargeRate: values.standardChargeRate
                }
            });
        } else {
            updateExtendedStaff({
            variables: {
                    partyGuid: values.partyGuid,
                    endDate: values.endDate ? moment(values.endDate).toDate() : values.endDate,
                    staffRole: values.staffClassification ? values.staffClassification.value : null,
                    startDate: values.startDate ? moment(values.startDate).toDate() : values.startDate,
                    standardChargeRate: values.standardChargeRate
                }
            });
        }
    };
    
    const onDiscardChanges = (form: FormApi<EditStaffBudgetForm>) => (agree: boolean) => {
        if (agree) {
            form.reset();
            setShowDiscard(false);

            if (props.onClose) {
                props.onClose();
            }
        } else {
            setShowDiscard(false);
        }
    };
    
    const onClose = (pristine: boolean) => () => {
        if (!pristine) {
            setShowDiscard(true);
        } else {
            if (props.onClose) {
                props.onClose();
            }
        }
    };

    const actionButton = (
        form: FormApi<EditStaffBudgetForm>,
        submitting: boolean,
        pristine: boolean,
        // tslint:disable-next-line: no-any
        values: any
    ) => {
        return (
            <div className={classes.butotnContainer}>
                <Button 
                    type="submit" 
                    color="primary"
                    disabled={submitting || pristine || updateStaffProperty.loading}
                    variant="contained"
                    className={classes.actionButton}
                >
                    Update
                </Button>
                <Button 
                    onClick={onClose(pristine)} 
                    color="primary"
                    variant="contained"
                    className={classes.actionButton}
                >
                    Cancel
                </Button>
            </div>
        );
    };

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={formState}
            initialValuesEqual={() => true}
            keepDirtyOnReinitialize={true}
            // validate={validate}
            render={({ 
                handleSubmit,
                form,
                submitting,
                pristine,
                values
                }) => (
                <>
                    <DialogBox
                        title="Edit Staff Details"
                        content="Are you sure you want to close the form?"
                        show={showDiscard}
                        isAgree={onDiscardChanges(form)}
                        disAgreeLabel="No"
                        agreeLabel="Yes"
                    />
                    <Drawer 
                        anchor="right" 
                        open={props.open} 
                        onClose={onClose(pristine)}
                        classes={{
                            paper: classes.paperRoot
                        }}
                    >
                        <form onSubmit={handleSubmit}>
                            <Grid container={true} spacing={3}>
                                <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                                    <Typography className={classes.title}>Edit Staff Details</Typography>
                                </Grid>
                                <FormSpy subscription={{values: true, validating: true}}>
                                    {/* tslint:disable-next-line: no-shadowed-variable */}
                                    {({ values }) => (
                                        <>
                                            <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                                                <Field
                                                    name="startDate"
                                                    // validate={form.getFieldState('startDate')?.value !== null ? required : undefined}
                                                >
                                                    {({ input, meta }) => (
                                                        <KeyboardDatePicker
                                                            {...input}
                                                            value={input.value ? input.value : null}
                                                            className={classes.textField}
                                                            id="startDate"
                                                            name="startDate"
                                                            label="Start Date"
                                                            format="DD/MM/YYYY"
                                                            placeholder="dd/mm/yyyy"
                                                            animateYearScrolling={true}
                                                            // tslint:disable-next-line: max-line-length
                                                            autoOk={true}
                                                            allowKeyboardControl={true}
                                                            variant={'inline'}
                                                            error={meta.error && meta.touched}
                                                            inputProps={{autoComplete: 'off'}}
                                                            InputLabelProps={{ shrink: true }}
                                                            helperText={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? 'Start date is required'
                                                                    : ''
                                                            }
                                                            initialFocusedDate={new Date().setHours(12, 0, 0, 0)}
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>
                                            <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                                                <Field
                                                    name="endDate"
                                                    // validate={form.getFieldState('endDate')?.value !== null ? required : undefined}
                                                >
                                                    {({ input, meta }) => (
                                                        <KeyboardDatePicker
                                                            {...input}
                                                            value={input.value ? input.value : null}
                                                            className={classes.textField}
                                                            id="endDate"
                                                            name="endDate"
                                                            label="End Date"
                                                            format="DD/MM/YYYY"
                                                            placeholder="dd/mm/yyyy"
                                                            animateYearScrolling={true}
                                                            // tslint:disable-next-line: max-line-length
                                                            autoOk={true}
                                                            allowKeyboardControl={true}
                                                            variant={'inline'}
                                                            error={meta.error && meta.touched}
                                                            inputProps={{autoComplete: 'off'}}
                                                            InputLabelProps={{ shrink: true }}
                                                            helperText={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? 'End date is required'
                                                                    : ''
                                                            }
                                                            minDate={values.startDate ? values.startDate : undefined}
                                                            initialFocusedDate={new Date().setHours(12, 0, 0, 0)}
                                                        />
                                                    )}
                                                </Field>
                                            </Grid>
                                            
                                        </>
                                    )}
                                </FormSpy>
                                <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                                    <Field
                                        name="staffClassification"
                                        // validate={required}
                                        // required={false}
                                        // validate={form.getFieldState('priority')?.value !== undefined ? required : undefined}
                                    >
                                        {({ input, meta }) => (
                                            <StaffSelectorAutoComplete
                                                {...input}
                                                label="Staff Classification"
                                                value={input.value ? input.value : null}
                                                // required={true}
                                                className={`${classes.textField}`}
                                                error={meta.error && meta.touched}
                                                    // tslint:disable-next-line: jsx-alignment
                                                onSelection={(selection: IAutoCompleteItem, name: string) => 
                                                    input.onChange(selection)
                                                }
                                                helperText={
                                                    meta.error &&
                                                    meta.touched
                                                        ? 'Staff Classification is required'
                                                        : ''
                                                }
                                                disablePortal={false}
                                            />
                                        )}
                                    </Field>
                                </Grid>
                                {pageState.chargeRateSyncSettings &&  (
                                    <Grid item={true} xs={12} sm={12} md={6} lg={6}>
                                        <Field
                                            name="standardChargeRate"
                                            // validate={form.getFieldState('endDate')?.value !== null ? required : undefined}
                                        >
                                            {({ input, meta }) => (
                                                <TextField
                                                    {...input}
                                                    value={input.value ? input.value : null}
                                                    className={classes.textField}
                                                    id="standardChargeRate"
                                                    name="standardChargeRate"
                                                    label="Standard Charge Rate"
                                                    placeholder="Enter standard charge rate"
                                                    error={meta.error && meta.touched}
                                                    type="number"
                                                    disabled={pageState?.chargeRateSyncSettings?.config?.enableChargeRateSync}
                                                    helperText={
                                                        meta.error &&
                                                        meta.touched
                                                            ? 'Standard charge rate is required'
                                                            : ''
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </Grid>
                                )}
                                <Grid item={true} xs={12} sm={12} md={12} lg={12}>
                                    {actionButton(form, submitting, pristine, values)}
                                </Grid>
                            </Grid>
                        </form>
                    </Drawer>
                </>
            )}
        />
    );
};

interface UpdateStaffMutationParams {
    partyGuid: string;
    startDate: Date | null;
    endDate: Date | null;
    staffRole: string | null;
    updateFromRedView: Boolean;
    standardChargeRate?: number | null;
}

interface UpdateExtendedStaffMutationParams {
    partyGuid: string;
    startDate: Date | null;
    endDate: Date | null;
    staffRole: string | null;
    standardChargeRate?: number | null;
}

const UPDATE_STAFF_MUTATION = gql`
    mutation UpdateStaffMutation(
    $partyGuid: String, 
    $startDate: DateTime, 
    $endDate: DateTime, 
    $staffRole: String, 
    $updateFromRedView: Boolean,
    $standardChargeRate: Decimal) {
        updateStaff(
            partyGuid: $partyGuid,
            startDate: $startDate,
            endDate: $endDate,
            staffRole: $staffRole,
            updateFromRedView: $updateFromRedView,
            standardChargeRate: $standardChargeRate
        )
    }
`;

const UPDATE_EXTENDED_STAFF_MUTATION = gql`
mutation UpdateExtendedStaffMutation(
    $partyGuid: String, 
    $startDate: DateTime, 
    $endDate: DateTime, 
    $staffRole: String, 
    $standardChargeRate: Decimal
) {
    updateExtendedStaff(
        partyGuid: $partyGuid,
        startDate: $startDate,
        endDate: $endDate,
        staffRole: $staffRole,
        standardChargeRate: $standardChargeRate
    )
}
`;